import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeathBenefit = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "deathBenefit",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12485",
			"data-name": "Path 12485",
			d: "M16.5,7h-9a1,1,0,0,0-1,1V9a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V8A1,1,0,0,0,16.5,7Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12486",
			"data-name": "Path 12486",
			d: "M15.591,7l1-1.992a1.5,1.5,0,0,0-1.97-2.033L12,4.183,9.383,2.975a1.5,1.5,0,0,0-1.97,2.033L8.409,7",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12487",
			"data-name": "Path 12487",
			d: "M7.75,10,6.033,12.747a5.5,5.5,0,0,0,.314,6.285h0A5.5,5.5,0,0,0,10.7,21.168h2.6a5.5,5.5,0,0,0,4.353-2.136h0a5.5,5.5,0,0,0,.315-6.286L16.251,10",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12488",
			"data-name": "Path 12488",
			d: "M0,0H24V24H0Z",
			fill: "none"
		})
	]
});
export default SvgDeathBenefit;
